import React from "react";
import Login from "./Login";
import DashboardHome from "./DashboardHome";

function App() {
  const token = localStorage.getItem("token");
  return <div>{token ? <DashboardHome /> : <Login />}</div>;
}

export default App;
